import React from 'react';
import './Legal.css';

const TermsOfService = () => {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <h1>Terms and Conditions of Use</h1>
        <p className="legal-fecha">Last updated: October 12, 2026</p>
        <p><a href="/terminos">Leer estos términos en español</a></p>

        <section>
          <h2>1. Acceptance of terms</h2>
          <p>
            By accessing and using the <strong>Xaltech Fotos</strong> platform (website and WhatsApp bot),
            you agree to be bound by these Terms and Conditions of Use. If you do not agree with any of
            these terms, please do not use the service. The platform is operated by
            <strong> Xaltech Manufacturing Services SA de CV</strong>.
          </p>
        </section>

        <section>
          <h2>2. Service description</h2>
          <p>
            Xaltech Fotos is a digital platform that connects sports photographers with athletes
            participating in public events, enabling the search, viewing, and purchase of photographs taken
            during those events, through an automated WhatsApp system and a web portal. Covered events may
            take place both in Mexico and in other countries.
          </p>
        </section>

        <section>
          <h2>3. Photographer registration</h2>
          <ul>
            <li>The photographer is responsible for the accuracy of the information provided upon registration.</li>
            <li>The photographer warrants that they hold the rights to the photographs they upload to the platform.</li>
            <li>The photographer is responsible for obtaining the event organizer's permission to take photographs.</li>
            <li>If the photographer covers events outside Mexico, they are responsible for complying with the local image rights, personal data, and tax laws of the corresponding country.</li>
            <li>Xaltech Fotos acts as an intermediary platform and is not responsible for content uploaded by photographers.</li>
          </ul>
        </section>

        <section>
          <h2>4. Purchasing photographs</h2>
          <ul>
            <li>Payments are securely processed through <strong>Stripe</strong>.</li>
            <li>Once payment is completed, the buyer will receive their high-resolution photographs via WhatsApp.</li>
            <li>Purchased photographs are for the buyer's personal use. Commercial redistribution is not permitted.</li>
            <li>No refunds are issued once digital photographs have been delivered, except for a verifiable technical error.</li>
          </ul>
        </section>

        <section>
          <h2>5. Platform commission</h2>
          <p>
            For each sale made through the platform, Xaltech Manufacturing Services SA de CV charges a
            commission for the technology intermediation service. Commission details are agreed directly
            with each registered photographer through an independent contract.
          </p>
        </section>

        <section>
          <h2>6. Photographs at public and private events; consent to image use</h2>
          <p>
            Photographs from <strong>public sporting events</strong> are taken at events open to general
            participation. Photography in public spaces and events is permitted under applicable law. By
            accepting these Terms and Conditions, the user acknowledges and expressly authorizes that their
            image captured at such public events may be stored, processed, and commercialized within the
            Xaltech Fotos platform, solely in the context of the sporting event in which they participated.
          </p>
          <p>
            For <strong>private events</strong> (weddings, graduations, baby showers, and similar), the
            registered photographer represents and warrants that they have obtained authorization from the
            event organizer, and where applicable from attendees, to photograph and commercialize those
            images through the platform. Xaltech Fotos does not participate in obtaining that authorization
            and is not responsible if the photographer breaches this warranty.
          </p>
          <p>
            If any of the photographs or selfies processed include the image of a minor, the person using
            the service on their behalf (whether sending the selfie or purchasing photographs) declares to
            be their parent or legal guardian and to be acting on their behalf.
          </p>
          <p>
            If the event takes place outside Mexico, the registered photographer is also responsible for
            complying with the local image rights and personal data laws applicable in the country where
            the event takes place.
          </p>
          <p>
            However, if any participant believes an image affects their image rights or dignity, they may
            request its removal by emailing <strong>xaltech1990@outlook.com</strong> with the photo and
            event number. We will handle the request within a maximum of 5 business days.
          </p>
        </section>

        <section>
          <h2>7. Automated WhatsApp messages</h2>
          <p>
            By interacting with the Xaltech Fotos WhatsApp bot, the user agrees to receive automated
            messages related exclusively to the service: photo search, purchase process, image delivery,
            and support. Xaltech Fotos will not send unsolicited advertising. The user may opt out of
            receiving messages at any time by sending the word <strong>STOP</strong> to the platform's
            WhatsApp number.
          </p>
        </section>

        <section>
          <h2>8. Intellectual property</h2>
          <p>
            Photographers retain copyright over their works. By uploading photographs to the platform, they
            grant Xaltech Fotos a non-exclusive license to display, distribute, and sell them within the
            platform. The design, code, and brand of Xaltech Fotos are the property of Xaltech Manufacturing
            Services SA de CV.
          </p>
        </section>

        <section>
          <h2>9. Limitation of liability</h2>
          <p>
            Xaltech Fotos will not be liable for indirect, incidental, or consequential damages arising from
            use of the platform. The Company's maximum liability is limited to the amount paid by the user
            in the corresponding transaction.
          </p>
        </section>

        <section>
          <h2>10. Modifications</h2>
          <p>
            We reserve the right to modify these terms at any time. Continued use of the platform after
            changes constitutes acceptance of the new terms.
          </p>
        </section>

        <section>
          <h2>11. Governing law and jurisdiction</h2>
          <p>
            These terms are generally governed by the laws of the <strong>United Mexican States</strong>,
            where Xaltech Manufacturing Services SA de CV is established. For any dispute, the parties
            submit to the jurisdiction of the competent courts of <strong>Guadalajara, Jalisco,
            Mexico</strong>, waiving any other venue that might otherwise apply by reason of their present
            or future domicile.
          </p>
          <p>
            This does not limit any non-waivable rights that local consumer-protection or data-protection
            law of the user's country of residence may grant, where such legislation is mandatorily
            applicable under its own law.
          </p>
        </section>

        <section>
          <h2>12. Contact</h2>
          <p>
            For any matter related to these terms:<br />
            📧 <strong>xaltech1990@outlook.com</strong>
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
